// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Accordion$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as CardTitleWithImage from "./CardTitleWithImage.bs.js";
import * as OrderLoaderComponent from "../../../library/map/views/OrderLoaderComponent.bs.js";
import * as NLOrderCommentsSection from "./comment-section/NLOrderCommentsSection.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as OrderDashboardAssetsManager from "../../../assets/OrderDashboardAssetsManager.bs.js";

var map_icon = OrderDashboardAssetsManager.getImage("map_icon.svg");

function getAccordianPanelForMap(order_id) {
  return AccordionTypes$Catalyst.make_props({
              TAG: /* Custom */1,
              _0: (function (param) {
                  return React.createElement(CardTitleWithImage.make, {
                              title: "Map",
                              icon_src: map_icon
                            });
                })
            }, undefined, undefined, React.createElement(OrderLoaderComponent.make, {
                  order_id: order_id
                }), undefined);
}

function NLOrderRightSection$OrderMap(Props) {
  var order_id = Props.order_id;
  return React.createElement(Accordion$Catalyst.make, {
              panels: {
                hd: getAccordianPanelForMap(order_id),
                tl: /* [] */0
              }
            });
}

var OrderMap = {
  map_icon: map_icon,
  getAccordianPanelForMap: getAccordianPanelForMap,
  make: NLOrderRightSection$OrderMap
};

var comments_icon = OrderDashboardAssetsManager.getImage("comments.svg");

function getAccordianPanelForMap$1(user, order_id, order_crn) {
  return AccordionTypes$Catalyst.make_props({
              TAG: /* Custom */1,
              _0: (function (param) {
                  return React.createElement(CardTitleWithImage.make, {
                              title: "Comments",
                              icon_src: comments_icon
                            });
                })
            }, undefined, undefined, React.createElement(NLOrderCommentsSection.make, {
                  user: user,
                  order_crn: order_crn,
                  order_id: order_id
                }), undefined);
}

function NLOrderRightSection$CommentsSection(Props) {
  var user = Props.user;
  var order_id = Props.order_id;
  var order_crn = Props.order_crn;
  return React.createElement(Accordion$Catalyst.make, {
              panels: {
                hd: getAccordianPanelForMap$1(user, order_id, order_crn),
                tl: /* [] */0
              }
            });
}

var CommentsSection = {
  comments_icon: comments_icon,
  getAccordianPanelForMap: getAccordianPanelForMap$1,
  make: NLOrderRightSection$CommentsSection
};

function NLOrderRightSection(Props) {
  var order_id = Props.order_id;
  var order_crn = Props.order_crn;
  var user = Props.user;
  return React.createElement("div", {
              className: "nlo-right-section"
            }, React.createElement(NLOrderRightSection$OrderMap, {
                  order_id: order_crn
                }), React.createElement(NLOrderRightSection$CommentsSection, {
                  user: user,
                  order_id: order_id,
                  order_crn: order_crn
                }));
}

var make = NLOrderRightSection;

export {
  OrderMap ,
  CommentsSection ,
  make ,
  
}
/* map_icon Not a pure module */
